import {propsReducer} from "utils/stateUtils";
import {CLIENT_SET_PROPS} from "actions";

const DEFAULT_STATE = {
  clients:[],
  clientDetails:null,
};

export default propsReducer(CLIENT_SET_PROPS, DEFAULT_STATE);
